/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Kontakte_Knupfen20Inputs */

const en__field_enum_icsrm_kontakte_knupfen20 = /** @type {(inputs: _Field_Enum_Icsrm_Kontakte_Knupfen20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other People`)
};

const de__field_enum_icsrm_kontakte_knupfen20 = /** @type {(inputs: _Field_Enum_Icsrm_Kontakte_Knupfen20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakte knüpfen`)
};

/**
* | output |
* | --- |
* | "Get to know other People" |
*
* @param {_Field_Enum_Icsrm_Kontakte_Knupfen20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_kontakte_knupfen20 = /** @type {((inputs?: _Field_Enum_Icsrm_Kontakte_Knupfen20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Kontakte_Knupfen20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_kontakte_knupfen20(inputs)
	return de__field_enum_icsrm_kontakte_knupfen20(inputs)
});
export { _field_enum_icsrm_kontakte_knupfen20 as "_field_enum_ICSRM_KONTAKTE_KNUPFEN" }